
<div class="transalte-box">
  <div class="translate-container">
    <div class="container">
      <div class="row mb-4 w-100">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>{{'FileUpload.Languages' | translate }}</mat-label>
            <mat-select (selectionChange)="onSelectionChangeSourceLanguage($event)" [(ngModel)]="selectedSourceLanguage">
              @for (key of sourceLanguages | async | keyvalue; track key) {
                <mat-option [value]="key.value">
                  {{key.key}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 text-center fw-bold align-self-center"><i class="bi bi-arrow-right fs-3"></i></div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>{{'FileUpload.Languages' | translate }}</mat-label>
            <mat-select (selectionChange)="onSelectionChangeTargetLanguage($event)" [(ngModel)]="selectedTargetLanguage">
              @for (key of targetLanguages | async | keyvalue; track key) {
                <mat-option [value]="key.value">
                  {{key.key}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (!isFileDropped) {
        <button class="drag-drop-area w-75"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave()"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
          [ngClass]="{'drag-over': isDragOver}">
          <p>📂 {{'FileUpload.DragAndDrop' | translate }}</p>
          <label for="fileDropRef" class="visually-hidden"></label>
        </button>
      }
      <input type="file" #fileInput (change)="onFileSelected($event)" hidden>
      @if (isFileDropped) {
        <div class="drag-drop-area w-75">
          <app-file-button [selectedFileName] = "this.selectedFile!.name" (isFileDropped) = "handleFileDelete($event)"></app-file-button>
        </div>
      }
      <br>
        <br>
          <div class="spinner-area">
            @if (isLoading) {
              <div class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            }
          </div>
        </div>
        <div class="filetype-info-box">
          <div class="exlamation-mark">
            <i class="bi bi-exclamation fs-1"></i>
          </div>
          <div class="info-text">
            <p class="filetype-info"> {{'FileUpload.FileTypeInfo' | translate}}</p>
          </div>
        </div>
      </div>
      <br>
        <br>
          <div class="translateButton">
            <button class="btn btn-primary" type="button" (click)="translateFile()">{{'FileUpload.Translate' | translate}}</button>
          </div>
          <div class ="translateOptions">
            <app-translation-options></app-translation-options>
          </div>
        </div>


